export function content() {
    document.querySelectorAll('ol[start]').forEach(ol => {
        const start = parseInt(ol.getAttribute('start'), 10);
        ol.style.counterReset = `counter ${start - 1}`;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/content.js